import type { JSX, MouseEvent, ReactNode } from 'react'

import { Button, CirclePlusIcon, Tooltip } from '@buffer-mono/popcorn'

import styles from './StartThreadButtonView.module.css'

export function StartThreadButtonView({
  tooltip,
  onClick,
  disabled,
  iconOnly,
  indicator,
}: {
  tooltip: string
  onClick: (event: MouseEvent<HTMLButtonElement>) => void
  disabled: boolean
  iconOnly: boolean
  indicator?: ReactNode
}): JSX.Element {
  return (
    <div className={styles.startThreadWrapper}>
      <Tooltip content={tooltip}>
        <Button
          className={styles.startThreadButton}
          variant="tertiary"
          size="medium"
          onClick={onClick}
          data-thread-disabled={disabled}
          data-icon-only={iconOnly}
          data-testid="add-post-to-thread-button"
        >
          <CirclePlusIcon />
          {!iconOnly && 'Start Thread'}
          {indicator}
        </Button>
      </Tooltip>
    </div>
  )
}
